"use strict";
exports.__esModule = true;
exports.cachePluginContext = exports.getCachedPluginContext = void 0;
var cache = new WeakMap();
function getCachedPluginContext(pluginName, sharedContext) {
    var contexts = cache.get(sharedContext);
    return contexts ? contexts[pluginName] : null;
}
exports.getCachedPluginContext = getCachedPluginContext;
function cachePluginContext(pluginName, sharedContext, context) {
    var contexts = cache.get(sharedContext);
    if (!contexts) {
        contexts = {};
        cache.set(sharedContext, contexts);
    }
    contexts[pluginName] = context;
}
exports.cachePluginContext = cachePluginContext;
